import { SearchFormType, UserSearchRequestType } from "../types/UsersSearch";

// export const deepDelete = (obj: any) => {
//   for (const key in obj) {
//     if (obj[key] === "undefined" || (typeof obj[key] === "object" && Object.keys(obj[key]).length === 0)) {
//       delete obj[key];
//     } else if (typeof obj[key] === "object") {
//       deepDelete(obj[key]);
//       if (Object.keys(obj[key]).length === 0) {
//         delete obj[key];
//       }
//     }
//   }
// };

export const getRequestAnomaly = (obj: SearchFormType): boolean => {
  if (obj.maxAge < obj.minAge) {
    return true;
  }
  if (obj.maxIncome < obj.minIncome) {
    return true;
  }
  if (
    obj.minHoldingPropertyCount !== "undefined" &&
    obj.maxHoldingPropertyCount !== "undefined" &&
    obj.maxHoldingPropertyCount < obj.minHoldingPropertyCount
  ) {
    return true;
  }
  return false;
};

export const usersFormToRequest = (obj: SearchFormType): UserSearchRequestType => {
  const {
    score,
    minAge,
    maxAge,
    minIncome,
    maxIncome,
    loanAmountMultiple,
    lengthOfService,
    useEstimatedLengthOfService,
    interestList,
    occupationList,
    industryList,
    financialAsset,
    minHoldingPropertyCount,
    maxHoldingPropertyCount,
    days_since_proposal,
    re_proposal_count,
    has_other_information,
    address_prefectures,
  } = obj;
  const normalizedScore = Array.isArray(score) ? score : [];
  const normalizedInterestList = Array.isArray(interestList) ? interestList : [];
  const normalizedOccupationList = Array.isArray(occupationList) ? occupationList : [];
  const normalizedIndustryList = Array.isArray(industryList) ? industryList : [];
  const normalizedFinancialAsset = Array.isArray(financialAsset) ? financialAsset : [];
  const normalizedDays = Array.isArray(days_since_proposal) ? days_since_proposal : [];
  const normalizedReproposalCount = Array.isArray(re_proposal_count) ? re_proposal_count : [];
  const normalizedAddressPrefectures = Array.isArray(address_prefectures) ? address_prefectures : [];

  const request: UserSearchRequestType = {};
  if (normalizedScore.includes(0)) {
    request.score = [null];
  } else if (normalizedScore.length > 0) {
    request.score = normalizedScore;
  }
  (minAge !== "undefined" || maxAge !== "undefined") && (request.age = {});
  minAge !== "undefined" && request.age && (request.age.min = Number(minAge));
  maxAge !== "undefined" && request.age && (request.age.max = Number(maxAge));

  (minIncome !== "undefined" || maxIncome !== "undefined") && (request.annual_income = {});
  minIncome !== "undefined" && request.annual_income && (request.annual_income.min = Number(minIncome));
  maxIncome !== "undefined" && request.annual_income && (request.annual_income.max = Number(maxIncome));

  loanAmountMultiple !== "undefined" && (request.loan_amount_income_multiple = Number(loanAmountMultiple));

  lengthOfService !== "undefined" && (request.job_continuous_year = Number(lengthOfService));
  useEstimatedLengthOfService && (request.use_estimated_job_continuous_period = true);
  normalizedInterestList.length !== 0 && (request.interested_property_type_ids = normalizedInterestList);
  normalizedOccupationList.length !== 0 && (request.job_category_ids = normalizedOccupationList);
  normalizedIndustryList.length !== 0 && (request.job_industry_ids = normalizedIndustryList);
  normalizedFinancialAsset.length !== 0 && (request.financial_asset = normalizedFinancialAsset);

  (minHoldingPropertyCount !== "undefined" || maxHoldingPropertyCount !== "undefined") &&
    (request.holding_property_count = {});
  minHoldingPropertyCount !== "undefined" &&
    request.holding_property_count &&
    (request.holding_property_count.min = Number(minHoldingPropertyCount));
  maxHoldingPropertyCount !== "undefined" &&
    request.holding_property_count &&
    (request.holding_property_count.max = Number(maxHoldingPropertyCount));

  normalizedDays.length > 0 && (request.days_since_proposal = normalizedDays);
  normalizedReproposalCount.length > 0 && (request.re_proposal_count = normalizedReproposalCount);

  has_other_information !== undefined && has_other_information !== false && (request.has_other_information = has_other_information);

  normalizedAddressPrefectures.length > 0 && (request.address_prefectures = normalizedAddressPrefectures);

  return request;
};
